"use client";

import Image from "next/image";
import { HOMEPAGE_COPY } from "@/lib/homepage/copy";

export default function HomepageTestimonialsSection() {
  const { heading, items } = HOMEPAGE_COPY.testimonials;

  return (
    <section className="w-full max-w-7xl mb-16" id="testimonials">
      <h2 className="text-3xl md:text-4xl font-semibold text-center mb-8">
        {heading}
      </h2>
      <div className="-mx-4 px-4 md:mx-0 md:px-0">
        <div
          className="flex gap-4 overflow-x-auto pb-2 snap-x snap-mandatory scroll-smooth [scrollbar-width:thin] md:grid md:grid-cols-3 md:overflow-visible md:pb-0"
          role="list"
        >
          {items.map((testimonial) => (
            <div
              key={testimonial.author}
              role="listitem"
              className="bg-surface p-6 rounded-xl shadow-md shrink-0 w-[min(85vw,20rem)] snap-start md:w-auto md:shrink"
            >
              <div className="flex items-center mb-4 justify-center">
                <Image
                  src={testimonial.image}
                  alt={`${testimonial.author} profile`}
                  className="w-12 h-12 rounded-full border-2 border-primary"
                  width={48}
                  height={48}
                />
              </div>
              <p className="text-center text-text-light mb-4">
                &quot;{testimonial.text}&quot;
              </p>
              <div className="flex justify-center text-center items-center">
                <div>
                  <p className="font-medium">{testimonial.author}</p>
                  <p className="text-sm text-text-light">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
